import { ordersApi } from '../services/ordersApi';

export const terminalGroupsQueryKey = ['terminalGroups'] as const;

export function terminalGroupsQueryOptions() {
  return {
    queryKey: terminalGroupsQueryKey,
    queryFn: () => ordersApi.getTerminalGroups(),
    staleTime: 60_000,
    gcTime: 1000 * 60 * 60,
  };
}
